import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import HeadTitle from 'src/components/atoms/HeadTitle'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { PointCard } from 'src/components/molecules/PointCard'
import { PointCardLayout } from 'src/components/molecules/PointCardLayout'

const points = [
  {
    imageName: 'group',
    title: 'グループ管理',
    description:
      'ユーザー属性に応じたコンテンツの出し分けが可能です。ユーザー体験を最も細やかなレベルで最適化することができます。'
  },
  {
    imageName: 'badge',
    title: 'ポイント/\nバッジ',
    description:
      'ユーザーの能動的なアクションを促す、ポイント機能・バッジ機能を搭載。特定のアクションに対するインセンティブ付与が簡単にできます。'
  },
  {
    imageName: 'knowledge_base',
    title: 'ナレッジベース/\nトレーニング',
    description:
      'ストック型コンテンツの蓄積やトレーニングに特化したUIを提供し、ユーザーの自己解決を促進。運営効率化をサポートします。'
  },
  {
    imageName: 'event',
    title: 'イベント',
    description:
      'オンライン・オフライン双方のイベント管理が簡単に。ユーザーの参加申込やユーザー管理がその場で可能になります。'
  },
  {
    imageName: 'q_and_a',
    title: 'Q&A',
    description:
      '質問・解答がしあえるQ&A機能を設置。ユーザーフォーラムや知恵袋のような機能が簡単に実装できます。'
  },
  {
    imageName: 'app',
    title: 'アプリ',
    description:
      'リテンションに効果的なコミュニティアプリを提供。プッシュ通知でユーザーに情報を直接届けます。自社オリジナルアプリも作成可能。'
  },
  {
    imageName: 'analysis',
    title: '分析',
    description:
      '純正の分析画面をご提供。タグの埋め込みは必要ありません。CSV export・API接続も可能で、BIツール等での詳細分析にも対応しています。'
  },
  {
    imageName: 'monitoring',
    title: '24時間365日\nモニタリング',
    description:
      '投稿やコメントをモニタリングし、活性化と炎上リスク抑制の両立を実現。ISMS認証も取得しており、安心して運用していただけます。'
  },
  {
    imageName: 'api',
    title: 'commmune API / SSO',
    description:
      'CRM/SFA/MAツールや自社サービスなど、APIを提供する外部サービスと連携可能。ご利用中のログインシステムも利用でき、IDに紐付く分析も容易になります。'
  }
]

export const TopFeatures = () => {
  const data = useStaticQuery(graphql`
    query {
      group: file(relativePath: { eq: "top/features/group.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      badge: file(relativePath: { eq: "top/features/badge.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      knowledge_base: file(
        relativePath: { eq: "top/features/knowledge_base.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      event: file(relativePath: { eq: "top/features/event.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      q_and_a: file(relativePath: { eq: "top/features/q_and_a.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      app: file(relativePath: { eq: "top/features/app.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      analysis: file(relativePath: { eq: "top/features/analysis.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      monitoring: file(relativePath: { eq: "top/features/monitoring.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      api: file(relativePath: { eq: "top/features/api.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Container>
      <ContentsWrapper>
        <HeadingBorder heading="FEATURES" />
        <HeadTitle>commmuneの提供機能</HeadTitle>
        <PointCardLayoutWrapper>
          <PointCardLayout>
            {points.map(point => {
              const { childImageSharp } = data[point.imageName]
              const imageFluid = childImageSharp && childImageSharp.fluid
              return (
                <PointCard
                  key={point.imageName}
                  {...point}
                  imageFluid={imageFluid}
                  spVariant="left"
                />
              )
            })}
          </PointCardLayout>
        </PointCardLayoutWrapper>
      </ContentsWrapper>
    </Container>
  )
}

const Container = styled.section`
  background-color: ${Styles.color.primary[200]};
  padding: ${Styles.spacing[11]} 0;
  @media screen and (min-width: ${BreakPoint.MOBILE}) {
    padding: ${Styles.spacing[14]} 0;
  }
`

const PointCardLayoutWrapper = styled.div`
  margin: ${Styles.spacing[11]} 0 0;
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    margin: ${Styles.spacing[12]} 0 0;
  }
`
